import React from 'react';
import MUIDataTable from "mui-datatables";
import CloseIcon from '@material-ui/icons/Close';
import { 
    Dialog,
    IconButton,
    Typography,
    CircularProgress
} from "@material-ui/core/";

import {OptionsDefault} from "../../../../../util/optionsTabelaDefault/.mixins";

import CardPedido from '../../../../cardPedido/.mixins/index';

//css
import Styles from './styles';
const useStyles = Styles();

export default ({
    descriptionsModalTable,
    itensTable,
    columns,
    isOpenModalTable,
    isLoading,
    FooterComponente,
    handleDialogModalTable,
    changePage,
    rowsPerPage,
    page,
    count,
})=>{
    const classes = useStyles();

    const HeaderModal = () => {
        return(
            <Typography>
                <IconButton aria-label="close" onClick={handleDialogModalTable} 
                    className={classes.closeButton}>
                    <CloseIcon />
                </IconButton>
                <CardPedido {...descriptionsModalTable}/>
            </Typography>
        )
    };

    const TableModal = () => {
        return(
            <div>
                <MUIDataTable 
                    maxWidth = {"md"}
                    data={itensTable} 
                    columns={columns} 
                    options={{
                        ...OptionsDefault,
                        selectableRows: 'none',
                        rowsPerPage,
                        page,
                        count,
                        serverSide: true,
                        onTableChange: (action, tableState) => {
                            if (action == 'changePage')
                                changePage(tableState.page, tableState.sortOrder);
                        }
                    }} 
                />
            </div>
        );
    };
    
    return(
        <div>
            <Dialog
                open={isOpenModalTable}
                maxWidth = {"md"}
                fullWidth
            >
                <HeaderModal/>    
                {isLoading &&
                    <div className={classes.loaderSpace} align="center">
                        <CircularProgress />
                        <p>Carregando Dados...</p>
                    </div>
                } 
                {!isLoading &&
                    <TableModal/>
                }
                {FooterComponente &&
                    <>
                        <FooterComponente/>
                    </>
                }
            </Dialog>
        </div>
    )
}
